import React from 'react';
import { formatBoolean, formatCost, formatDatetime, formatEmail } from '../../../utils';
import dayJs from 'dayjs';
import { DisclosureWaiver } from '.';
import { IUser } from '../../../globals/interfaces';
import moment from 'moment';

export default function Waiver({
    waiver,
    user,
    stationInfo
}: {
    waiver: DisclosureWaiver;
    user: IUser;
    stationInfo: any;
}) {

    const now = dayJs().format('MM/DD/YYYY hh:mm A');

    return (
        <div dangerouslySetInnerHTML={{
            __html: `
            <html>
                <head>
                    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous">
                </head>
                <body>
                    <style>
                        body {
                            border: 20px solid white;
                            -webkit-print-color-adjust: exact !important;
                        }
                
                        .bg-blue {
                            background-color: 	rgb(64, 159, 216) !important;
                        }
                
                        .bg-grey {
                                background-color: 	rgb(225, 221, 220) !important;
                        }
                
                        .slanting-line {
                            height: 24px;
                            width: 10px;
                            position: relative;
                            top: -5px;
                        }
                
                        .table-row-info {
                            text-align: center;
                            display: inline-block;
                        }
                
                        tbody tr:nth-child(odd){
                            background-color: #d5edfd !important;
                        }
                
                        tbody tr:nth-child(even){
                            background-color: #ffffff !important;
                        }
                
                        .table th {
                            background-color:	rgb(64, 159, 216) !important;
                            color: white !important;
                        }
                
                        .img-small {
                            width: '10px';
                            height: auto;
                        }
                
                        .text-blue {
                            color: rgb(64, 159, 216)
                        }
                
                        .test-background {
                            background-color: #f17150 !important;
                        }
                
                        /* * {
                            border: 1px solid red;
                        } */
                
                        .text-white-custom {
                            color: black !important;
                            font-weight: bold;
                        }
                
                        .align-right {
                            text-align: right;
                        }

                        @media print {
                
                            @page {                
                                size: A4;
                                margin: 0mm;
                            }
                
                            html, body, .row {
                                width: 1024px;
                            }
                
                            body {
                                margin: 0 auto;
                            }
                
                            .bg-blue {
                                background-color:	rgb(64, 159, 216) !important;
                            }
                
                            .bg-grey {
                                background-color: 	rgb(225, 221, 220) !important;
                            }
                
                            .table th {
                                background-color:	rgb(64, 159, 216) !important;
                                color: white !important;
                            }
                
                            tbody>tr:nth-child(odd)>td {
                                background-color: #d5edfd !important;
                            }
                
                            tbody>tr:nth-child(even)>td {
                                background-color: #ffffff !important;
                            }
                
                            .text-blue {
                                color: rgb(64, 159, 216) !important;
                            }
                
                            .text-white-custom {
                                color: white !important;
                                font-weight: bold;
                            }
                
                            .test-background {
                                background-color: #f17150 !important;
                            }
                
                            .rectangle {
                                width: 250px;
                                background-color: rgb(64, 159, 216) !important;
                                border-radius: 1.75px;
                                left: 770;
                            }
                
                        }
                    </style>
                    <div class='container-fluid' style='margin-top: 20px'>
                        <div class='row'>
                            <div class='col-xs-4' style='padding-left: 40px;'>
                                <img src='https://ewrstorage1.blob.core.windows.net/pics/choice.pod.logo.01.png' style='width: 300px; height: auto' />
                            </div>
                            <div class='col-xs-2' style='height: 175px;'>
                                <img style='width: 100px; height: auto;' src='https://ewrstorage1.blob.core.windows.net/pics/choice.pod.add.01.png' />
                                <h6>${stationInfo.s_address || ''}</h6>
                            </div>
                            <div class='col-xs-2'>
                                <img style='width: 100px; height: auto;' src='https://ewrstorage1.blob.core.windows.net/pics/choice.pod.phone.01.png' />
                                <h6>${stationInfo.s_phone || ''}</h6>
                            </div>
                            <div class='col-xs-2'>
                                <img style='width: 100px; height: auto;' src='https://ewrstorage1.blob.core.windows.net/pics/choice.pod.email.01.png' />
                                <h6>${stationInfo.distributionEmail || ''}</h6>
                            </div>
                            <div class='col-xs-2'>
                                <img style='width: 100px; height: auto;' src='https://ewrstorage1.blob.core.windows.net/pics/choice.pod.web.01.png' />
                                <h6>www.choice.aero</h6>
                            </div>
                        </div>
                        <div class='row' style='margin-left: 15px;'>
                            <div class='col-xs-12'>
                                <h1>Disclosure Waiver Acknowledgement</h1>
                            </div>
                        </div>
                        <div class='row' style='margin-top: 40px; margin-left: 30px; margin-right: 100px; width: 900px'>
                            <div class='col-12'>
                            <h4>Date: ${moment(waiver.created).format('MM/DD/YYYY HH:mm')}</h4>
                            <h4>Email: ${waiver.email}</h4>
                            <h4>Name: ${waiver.name}</h4>
                            <h4>MAWB/HAWB: ${waiver.mawb}</h4>
                            <h4>Total Amount: ${waiver.amount}</h4>
                            <h4>Authority to Agree: ${formatBoolean(waiver.authorityToAgree)}</h4>
                            <div>
                            Only an individual with proper authority within your company may accept these terms.

Representation & Warranty: By answering this question as described below you represent and warrant that you are authorized to bind your company to these terms for this AWB and pick up.

Reliance: Choice Aviation Services will rely on your reply as conclusive evidence of your authority. If you are not authorized, do not reply instead, please forward this form to an authorized signatory.

Do you confirm that you have the authority to agree to these terms on behalf of your company?                         
</div>
<p>&nbsp;</p>   
                            <h4>Special Rate Exception Agreement: ${formatBoolean(waiver.specialRateExceptionAgreement)}</h4>
                            <div>This special rate is provided as a one-time exception and is valid as communicated. It is not subject to change, dispute, or adjustment. All storage rates remain governed by our existing agreement with the airline. While this exception has been granted for your benefit, it does not constitute a guarantee that similar exceptions will be offered in the future. Choice Aviation Services reserves the right to modify, revoke, or discontinue this special rate at any time and to apply standard published rates without prior notice.</div>
                            <p>&nbsp;</p> 
                            <h4>Legal Enforceability Agreement: ${formatBoolean(waiver.legalEnforceabilityAgreement)}</h4>
                            <div>This disclosure constitute a binding agreement between the customer and Choice Aviation Services for the AWB mentioned in this email. Any attempt to dispute this charge outside these terms will be treated as a breach and may be pursued through available legal remedies.</div>
                            <p>&nbsp;</p> 
                            <h4>Payment & Non‑Dispute Agreement: ${formatBoolean(waiver.paymentNonDisputeAgreement)}</h4>
                            <div>By making payment, you acknowledge and agree to the terms of this disclosure. The charge is valid for AWB mentioned in this form and, to the fullest extent permitted by applicable law and any existing written agreement, is not disputable through any bank, card issuer, payment network, payment platform, or other means, except in cases of proven fraud or manifest billing error.</div>
                            <p>&nbsp;</p> 
                            </div>
                        </div>  
                        <div style='position: fixed; bottom: 30; margin-left: 30px;'>
                            <h6>Requested by ${user.displayName} on ${now}</h6>
                        </div>      
                    </div>
                    <script>
                        setTimeout(() => {
                            window.print();
                        }, 1000);
                    </script>
                </body>
                </html>
        `}}></div>
    );
}   